import angular from 'angular';
import {BaseModel} from '../jangl/BaseModel.js';

export class TorchmarkDataModel extends BaseModel {
     
     /**
     * @param {object} initializer - {
     *          first_name                    string    required   First name
     *          last_name                     string    required   Last name
     *          address                       string    optional   Address
     *          city                          string    required   City
     *          state                         string    required   State
     *          zip_code                      integer   required   Zip code
     *          phone                         string    required   Phone number
     *          phone2                        string    optional   Alternate phone number
     *          email                         string    optional   Email
     *          birth_date                    string    required   Birth date
     * }
     */
    constructor(initializer) {
        let init = (initializer) ? angular.copy(initializer) : {};
        let required =  [
            'first_name', 'last_name', 'state', 'city', 'zip_code', 'phone', 'birth_date'
        ];
        super(required, init);
    }

    serialize() {
        let serialized = super.serialize();
        serialized.birth_date = (serialized.birth_date && serialized.birth_date.day && serialized.birth_date.month >= 0
            && serialized.birth_date.year) ? this.serializeDropdownDate(serialized.birth_date) : null;
        return serialized;
    }
}

export class LifeDataModel extends BaseModel {

     /**
     * @param {object} initializer - {
     *          first_name       string    required   First name
     *          last_name        string    required   Last name
     *          birth_date       string    required   Birth date
     *          age              integer   required   Age
     * }
     */
    constructor(initializer) {
        let init = (initializer) ? angular.copy(initializer) : {};
        let required =  [
            'first_name', 'last_name', 'birth_date', 'age'
        ];
        super(required, init);
    }
}

export class HealthDataModel extends BaseModel {

     /**
     * @param {object} initializer - {
     *          first_name       string    required   First name
     *          last_name        string    required   Last name
     *          birth_date       string    required   Birth date
     *          age              integer   optional   Age
     * }
     */
    constructor(initializer) {
        let init = (initializer) ? angular.copy(initializer) : {};
        let required =  [
            'first_name', 'last_name', 'birth_date', 'age'
        ];
        super(required, init);
    }
}



// WEBPACK FOOTER //
// ./app/torchmark/models.js